import React from 'react';

const Code = () => {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.3125 7.25L12.0834 22.3542" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M7.85417 10.2708L3.625 14.4999L7.85417 18.7291" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M21.1459 10.2708L25.375 14.4999L21.1459 18.7291" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default Code;